$('[data-main-logo-hover-effect]').mouseenter(() => {
  const $mainLogo = $('[data-logo-main]');
  const $logoHover = $('[data-logo-hover]');
  $mainLogo.addClass('hide');
  $logoHover.removeClass('hide');
});

$('[data-main-logo-hover-effect]').mouseleave(() => {
  const $mainLogo = $('[data-logo-main]');
  const $logoHover = $('[data-logo-hover]');
  $mainLogo.removeClass('hide');
  $logoHover.addClass('hide');
});
